import { render, staticRenderFns } from "./TodoTaskEdit.vue?vue&type=template&id=2f07df3a&scoped=true"
import script from "./TodoTaskEdit.vue?vue&type=script&lang=js"
export * from "./TodoTaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TodoTaskEdit.vue?vue&type=style&index=0&id=2f07df3a&prod&lang=scss"
import style1 from "./TodoTaskEdit.vue?vue&type=style&index=1&id=2f07df3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07df3a",
  null
  
)

export default component.exports